import { useMediaQuery } from '@mui/material';

interface HookParams {
  prefix: 'min' | 'max';
  breakpointValue: number;
}

export const useIsMatchingMedia = ({ breakpointValue, prefix }: HookParams) => useMediaQuery(`(${prefix}-width:${breakpointValue}px)`);
